import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthGuard } from './components/AuthGuard';
import { LoginPage } from '@/pages/LoginPage';
import { AppsView } from '@/pages/AppsView';
import { TenantsView } from '@/pages/TenantsView/TenantsView';

const appRoutes = [
  { path: 'apps', element: <AppsView /> },
  // 其他路由暂时重定向到 apps
  { path: 'tools', element: <AppsView /> },
  { path: 'wins', element: <AppsView /> },
  { path: 'knowledge', element: <AppsView /> },
  { path: 'connectors', element: <AppsView /> },
  { path: 'monitor-tasks', element: <AppsView /> },
  { path: 'webhooks', element: <AppsView /> },
  { path: 'skillhub', element: <AppsView /> },
  { path: 'call-management', element: <AppsView /> },
  { path: 'sessions', element: <AppsView /> },
  { path: 'docs', element: <AppsView /> },
  { path: 'deploy', element: <AppsView /> },
  { path: 'remote', element: <AppsView /> },
  { path: 'org', element: <AppsView /> },
  { path: 'tenants', element: <TenantsView /> },
];

const ProtectedLayout = () => (
  <AuthGuard>
    <Layout />
  </AuthGuard>
);

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/:tenantId/login', element: <LoginPage /> },
  {
    path: '/',
    element: <ProtectedLayout />,
    children: [
      { index: true, element: <Navigate to="/apps" replace /> },
      ...appRoutes,
    ],
  },
  {
    path: '/:tenantId',
    element: <ProtectedLayout />,
    children: [
      { index: true, element: <Navigate to="apps" replace /> },
      ...appRoutes,
    ],
  },
]);
